module.exports = __webpack_public_path__ + "static/media/SG.4e33c59a.webp";